import React from "react";
import { Box, Container, Grid, Typography } from "@mui/material";
import capelliSportLogo from "../../images/logos/capelli-sport-logo-no-bg-2.webp";
import sportsRecruitsLogo from "../../images/logos/sports-recruits-logo.png";
import wegmansMeals2goLogo from "../../images/logos/wegmanMeals2go-no-bg.png";
import inspireMentalFitnessLogo from "../../images/logos/inspire-mental-fitness-logo.webp";
import bygaLogo from "../../images/logos/byga-logo.webp";
import theCoachingManual from "../../images/logos/the-coaching-manual-logo.png";
import valleyBank from "../../images/logos/valley-bank-logo.png";

const partners = [
  { name: "Capelli Sport", logo: capelliSportLogo },
  { name: "SportsRecruits", logo: sportsRecruitsLogo },
  { name: "Wegmans Meals 2GO", logo: wegmansMeals2goLogo },
  { name: "Inspire Mental Fitness", logo: inspireMentalFitnessLogo },
  { name: "BYGA", logo: bygaLogo },
  { name: "The Coaching Manual", logo: theCoachingManual },
  { name: "Valley Bank", logo: valleyBank },
];

const Partners = () => {
  return (
    <Box component="section" id="partners" sx={{ py: { xs: 6, md: 8 }, backgroundColor: "#f7f8fa" }}>
      <Container maxWidth="lg">
        <Typography
          variant="h2"
          sx={{
            mb: { xs: 4, md: 5 },
            display: "flex",
            justifyContent: "center",
            textAlign: "center",
            color: "#002c7d",
            fontSize: { xs: "2rem", sm: "2.5rem", md: "3rem" },
          }}
        >
          <Box
            component="span"
            sx={{
              display: "inline-block",
              position: "relative",
              pb: "12px",
              "&::after": {
                content: '""',
                position: "absolute",
                left: "22.5%",
                width: "55%",
                bottom: 0,
                height: "3px",
                backgroundColor: "currentColor",
              },
            }}
          >
            Our Partners
          </Box>
        </Typography>
        <Grid container spacing={{ xs: 2, sm: 3 }} alignItems="center" justifyContent="center">
          {partners.map((partner) => (
            <Grid item key={partner.name} xs={6} sm={4} md={2.4} sx={{ display: "flex", justifyContent: "center" }}>
              <Box
                component="img"
                src={partner.logo}
                alt={partner.name}
                sx={{ width: "100%", maxWidth: 170, height: 90, objectFit: "contain" }}
              />
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default Partners;